export default {
  'meta': {
    'langName': 'THAI',
    'lang': 'ไทย'
  },
  'title': 'ประกาศเรียกคืนสินค้า: แป้นบาสเกตบอลรุ่น B900 Box NBA TARMAK',
  'description': 'เราได้ตรวจพบความเสี่ยงที่เสาของแป้นบาสเกตบอลรุ่น B900 อาจร่วงหล่น หากมีการใช้งานโดยไม่มีมือหมุนปรับระดับความสูงและมีการเคลื่อนย้ายผลิตภัณฑ์\n\nเพื่อความปลอดภัยของคุณ กรุณาหยุดใช้งานทันทีหากแป้นบาสเกตบอลไม่ได้ติดตั้งมือหมุนปรับระดับความสูง\n\nคุณสามารถทำให้ผลิตภัณฑ์ปลอดภัยได้ด้วยขั้นตอนง่าย ๆ โดยเราจะจัดส่งชุดอุปกรณ์สำหรับซ่อมแซมให้ฟรี\n\nขณะนี้ เว็บไซต์เฉพาะกิจสำหรับการเรียกคืนผลิตภัณฑ์กำลังอยู่ระหว่างการพัฒนา ซึ่งจะมีคำแนะนำอย่างละเอียดสำหรับการดำเนินการ',
  'status': 'Translation validated by COUNTRY'
} as const
